// extracted by mini-css-extract-plugin
export default {"bannerWrapper":"_3uawOgZ_HP1IoN4CoPq5jL","bannerText":"_33arkTNHxvzqZiAWvQu9m7"};